import React, {Component} from 'react';
import {FieldArray} from 'redux-form';
import {
  Card,
  Icon,
  Form,
  Table,
  Popup,
} from 'semantic-ui-react';
import CheckingDetail from './detail';

class CheckingTable extends Component {
  constructor(props) {
    super(props);
    this.renderTable = this.renderTable.bind(this);
  }

  refreshStorageCarsOccupied() {
    this.props.fetchStorageCars('occupied');
  }

  addItem(fields) {
    const {lastStorageCarSelected} = this.props;
    fields.push({'storageCar': lastStorageCarSelected});
  }

  renderItems(fields) {
    const {selectedInvoice, newItems} = this.props;
    if (selectedInvoice === '') {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={12}>
            Seleccione una Factura
          </Table.Cell>
        </Table.Row>
      );
    }
    return <CheckingDetail selectedInvoice={selectedInvoice} newItems={newItems} fields={fields} />;
  }

  renderTable({fields}) {
    return (
      <div>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                textAlign='center'
                className='storage-car-column'
              >
                Coche
                <Popup
                  trigger={
                    <Icon
                      link
                      name='refresh'
                      color='blue'
                      size='large'
                      onClick={() => this.refreshStorageCarsOccupied()}
                    />
                  }
                  on='click'
                  position='bottom left'
                  inverted
                >
                  <div>Actualiza la lista de coches libres</div>
                </Popup>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='date-column'>
                Fecha
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='box-column'>
                Caja No.
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='part-code-column'>
                Código
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='part-name-column'>
                Descripción
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='location-column'>
                Ubicación
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='stock-column'>
                Stock
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                className='expected-quantity-column'
              >
                Caja
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                className='received-quantity-column'
              >
                Recibido
              </Table.HeaderCell>
              <Table.HeaderCell
                textAlign='center'
                className='back-order-column'
              >
                BO
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='label-column'>
                Etiqueta
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='left' className='quantity-column'>
                Conteo Físico
                <Popup
                  trigger={
                    <Icon link name='info circle' color='blue' size='big' />
                  }
                  on='click'
                  position='bottom left'
                  inverted
                >
                  <div>
                    <p>Definición de:</p>
                    <ul>
                      <li>
                        <strong>Stock:</strong> Existencia en bodega CDP
                      </li>
                      <li>
                        <strong>Caja:</strong> Número de items que vienen en la
                        caja
                      </li>
                      <li>
                        <strong>Recibido:</strong> Número de items que ya han
                        sido recibidos de la caja
                      </li>
                      <li>
                        <strong>BO:</strong> Número de items en Backs Orders
                      </li>
                      <li>
                        <strong>Etiqueta:</strong> Número de etiquetas que han
                        sido emitidas para esa línea
                      </li>
                    </ul>
                  </div>
                </Popup>
              </Table.HeaderCell>
              <Table.HeaderCell textAlign='center' className='print-column' />
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderItems(fields)}</Table.Body>
        </Table>

        <div className='addItem' onClick={() => this.addItem(fields)}>
          <Icon name='add' />
          <strong>AGREGAR REGISTRO</strong>
        </div>
      </div>
    );
  }

  render() {
    const {selectedInvoice} = this.props;
    return (
      selectedInvoice !== '' && (
        <Card fluid raised>
          <Form className='primary-content'>
            <FieldArray name='newItems' component={this.renderTable} />
          </Form>
        </Card>
      )
    );
  }
}

export default CheckingTable;
